import { Empty, type EmptyProps } from 'antd';

/** Compact normal empty state. Explicit descriptions remain available for errors. */
function QuietEmpty({
  children,
  description = false,
  styles,
  ...props
}: EmptyProps) {
  return (
    <fieldset
      style={{ border: 0, padding: 0, margin: 0, minInlineSize: 0 }}
      aria-label={
        typeof description === 'string' && description.trim()
          ? description
          : '空数据'
      }
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        {...props}
        description={description}
        styles={(info) => {
          const resolved = typeof styles === 'function' ? styles(info) : styles;
          return {
            ...resolved,
            root: { marginBlock: 12, ...resolved?.root },
            image: { height: 32, ...resolved?.image },
          };
        }}
      >
        {children}
      </Empty>
    </fieldset>
  );
}

QuietEmpty.PRESENTED_IMAGE_SIMPLE = Empty.PRESENTED_IMAGE_SIMPLE;
QuietEmpty.PRESENTED_IMAGE_DEFAULT = Empty.PRESENTED_IMAGE_DEFAULT;
export default QuietEmpty;
